import React, { Component } from "react";

class Task extends Component {
  state = {
    filters: {},
  };

  convertMS(ms) {
    var d, h, m, s;
    s = Math.floor(ms / 1000);
    m = Math.floor(s / 60);
    s = s % 60;
    h = Math.floor(m / 60);
    m = m % 60;
    d = Math.floor(h / 24);
    h = h % 24;
    h += d * 24;
    return d + " d " + h + ":" + m + ":" + s;
  }

  constructor() {
    super();
    this.handleRemove = this.handleRemove.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleRemove() {
    this.props.startRemovingTask(this.props.userid, this.props.taskid);
    this.props.startLoadingTasks(this.props.filters, this.props.userid);
  }

  handleClose() {
    // console.log(this.props.filters, "handle close");
    this.props.startClosingTask(this.props.userid, this.props.taskid);
    this.props.startLoadingTasks();
  }

  render() {
    const task = this.props.task;
    const timeElapsed = Date.now() - Date.parse(task.createdAt);
    const elapsed = this.convertMS(timeElapsed);
    return (
      <tr>
        <td className="w-50" style={{ wordBreak: "break-word" }}>
          {task.taskName}
        </td>
        <td className="w-10">{task.taskStatus}</td>
        {/*<td className="w-40">
          <div className="progress">
            <div
              className="progress-bar"
              style={{ width: `${35}%` }}
            >{`${35}%`}</div>
          </div>
    </td>*/}
        <td className="w-10">
          <button className="btn btn-danger" onClick={this.handleRemove}>
            Remove
          </button>
        </td>
        <td className="W10">{elapsed}</td>
        <td className="w-10">
          {task.taskStatus === "Open" ? (
            <button className="btn btn-primary" onClick={this.handleClose}>
              Close
            </button>
          ) : (
            ""
          )}
        </td>
        <td className="W10">{task.assignedBy}</td>
      </tr>
    );
  }
}

export default Task;
